module.exports = __webpack_public_path__ + "static/media/key-visual.e41c1b9e.png";